import React from 'react';
import {VISUAL_TOGGLES_ICON} from '../../../constants/visualToggles';

// Значок панели оверлеев/футера в тексте правил: те же иконки, что на самих
// кнопках, размером со строку
const ToggleIcon = ({src, title}) => (
  <img
    className={'rules-page_ui-icon'}
    src={src}
    alt={title}
    title={title}
  />
);

const InterfaceRules = () => {
  const undo = <ToggleIcon src={'/img/icons/return.png'} title={'Отмена действия'}/>;
  const info = <ToggleIcon src={'/img/icons/info.png'} title={'Информация о фазе'}/>;
  const deselect = <ToggleIcon src={'/img/icons/exit.png'} title={'Снять выделение'}/>;
  const expand = <ToggleIcon src={'/img/icons/expand.png'} title={'Свернуть/развернуть'}/>;
  const layers = <ToggleIcon src={VISUAL_TOGGLES_ICON} title={'Слои поля'}/>;
  const chat = <ToggleIcon src={'/img/icons/chat.png'} title={'Реакции'}/>;
  const supply = <img
    className={'policy-description-icon'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;
  const farm = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/farm.699e6dfc.png'}
    alt={'Ферма'}
    title={'Ферма'}
  />;
  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title">
        <img
          className={'rules-page_title-icon'}
          src={'/img/icons/free action.png'}
          alt={''}
          aria-hidden={'true'}
        />
        Интерфейс
      </h2>

      <div className="rules-page_section">
        <p>
          Раздел о том, как устроено управление и что показывают элементы экрана. На правила игры это не влияет —
          только на удобство.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Осмотр ячейки</h2>
        <p>
          Клик по <b>любой</b> ячейке поля (своей, чужой, пустой) показывает в нижней панели сведения о ней:
          строение и его владельца, отряд с его характеристиками, доход ключевой точки. Работает в любую фазу, в том
          числе в чужой ход — пока идет ход соперника, поле можно спокойно изучать.
        </p>
        <p>
          Если в ячейке гильдия или храм, вместе с осмотром проигрывается анимация: подсвечиваются пути влияния до
          городов соперников и итоговый доход строения. Города соперников, до которых дотянулись пути, подсвечиваются
          цветом их владельца.
        </p>
        <p>
          Снять выделение — кнопка {deselect} в шапке нижней панели или повторный клик по той же ячейке. Если в
          ячейке есть действие текущей фазы (например, можно построить или снабдить), клик выполняет действие, а не
          осмотр.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Отмена действий</h2>
        <p>
          Кнопка {undo} в шапке нижней панели отменяет <b>последнее действие текущего хода</b> и возвращает
          потраченные монеты, снабжение или действия строительства. Нажимать можно сколько угодно раз подряд, откатывая
          ход шаг за шагом. Отменить действие из середины хода, не трогая сделанного после него, можно двойным кликом
          по полю — см. следующий раздел.
        </p>
        <p>
          Пока в нижней панели открыт осмотр ячейки, кнопки {undo} в шапке нет — снимите выделение кнопкой {deselect},
          и она вернется.
        </p>
        <p>Отмена доступна:</p>
        <ul>
          <li>в фазе Строительства — постройки и ремонты;</li>
          <li>в фазе Снабжения — раздача снабжения {supply};</li>
          <li>в фазе Войны — найм, перемещение и маневр.</li>
        </ul>
        <p>
          На этапах <b>стрельбы</b> и <b>ближнего боя</b> отмены нет: кости уже брошены, и результат сразу видят все
          игроки.
        </p>
        <p>
          <b>После завершения хода отменить действия нельзя.</b> Кнопка откатывает только то, что сделано в текущем
          ходу и еще не подтверждено его завершением. В фазе Войны так же закрепляется <b>каждый этап</b>: отменить
          можно только действия текущего этапа — завершив, например, найм, на этапе перемещения отменить его уже не
          получится ни кнопкой, ни двойным кликом.
        </p>
        <p>
          В сетевой игре фазу Снабжения все игроки ходят одновременно: завершив свой ход, свое распределение снабжения
          {supply} уже не изменить, даже пока соперники еще распределяют свое.
        </p>
        <p>
          <b>Если время хода в фазе Строительства вышло</b>, а новые строения размещены некорректно, ход завершается
          автоматически, и игра сама отменяет <b>только некорректные строения</b> и те действия, которые без них
          нельзя было сделать, — например, дорогу, до которой путь строительства дотянулся только через отмененную
          казарму. Остальные действия хода сохраняются. Монеты за отмененное возвращаются, действия строительства
          освобождаются.
        </p>
        <p>
          Если друг другу мешают два новых строения (например, два квартала разных городов стоят ближе допустимого),
          отменяется то, вместе с которым уходит меньше действий; при равенстве остается построенное раньше. Игрок,
          чей был ход, получает сообщение со списком отмененного.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Точечная отмена двойным кликом</h2>
        <p>
          Кнопка {undo} откатывает действия строго по порядку, с последнего. Чтобы отменить действие из середины хода,
          не трогая сделанного после него, дважды кликните по нему на поле:
        </p>
        <ul>
          <li>
            <b>в фазе Строительства</b> — по ячейке с постройкой или ремонтом этого хода: отменяется последнее
            действие строительства в этой ячейке, монеты и действие строительства возвращаются. Если в ячейке за ход
            сделано несколько действий (например, квартал и крепость на нем), они снимаются по одному, начиная с
            последнего;
          </li>
          <li>
            <b>в фазе Войны на этапе найма</b> — по своему {unit} отряду, нанятому или усиленному в этом ходу:
            снимается последнее действие найма этого отряда — докупленный размер или улучшение, по одному за двойной
            клик, а в последнюю очередь и сам найм отряда. Монеты возвращаются;
          </li>
          <li>
            <b>в фазе Войны на этапах перемещения и маневра</b> — по своему {unit} отряду, который уже переместился
            (совершил маневр): отряд возвращается на исходную ячейку и может ходить снова;
          </li>
          <li>
            <b>в фазе Снабжения</b> — по отряду или ферме, подробнее в следующем разделе.
          </li>
        </ul>
        <p>
          Точечная отмена не может задним числом нарушить то, что сделано после нее, поэтому иногда она недоступна:
        </p>
        <ul>
          <li>
            постройка не отменяется, если без нее было бы невозможно какое-то из более поздних действий этого хода:
            постройка (например, дорога, проложенная дальше по отменяемой дороге) или ремонт строения, которое вошло
            в ваш город только благодаря отменяемому кварталу, — сначала отмените то действие;
          </li>
          <li>
            отряд не вернется, если его исходную ячейку уже занял другой отряд, — сначала отмените перемещение того
            отряда (на этапе маневра — его маневр);
          </li>
          <li>
            улучшение отряда не отменится, если с прежним типом у вас оказалось бы больше отрядов этого типа, чем
            разрешено, — сначала отмените найм более позднего отряда этого типа.
          </li>
        </ul>
        <p>
          В фазах Строительства и Войны двойной клик отменяет только то, что сделано до него: по пустой ячейке он
          по-прежнему строит, по свободной казарме — нанимает отряд, а по цели перемещения — перемещает его. Если же в
          ячейке есть постройка этого хода, а
          первый клик пары успел поставить что-то поверх нее (например, при выбранной крепости), снимается и то и другое.
          В фазе Снабжения двойной клик устроен иначе — см. следующий раздел.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Быстрые действия в фазе Снабжения</h2>
        <p>
          Раздача снабжения — самая «кликательная» часть партии, поэтому у нее есть отдельные сокращения.
        </p>
        <ul>
          <li>
            <b>Двойной клик по своему отряду</b> {unit} — снимает с него снабжение: сначала дополнительное, повторный
            двойной клик — базовое. Единицы снабжения {supply} возвращаются фермам, с которых были отданы.
          </li>
          <li>
            <b>Двойной клик по своей ферме</b> {farm} — возвращает ферме последнюю отданную с нее единицу
            снабжения {supply}. Если на ферме стоит свой снабженный отряд, двойной клик сначала отменяет снабжение
            этого отряда — ферма освобождается следующими двойными кликами. Исключение — дополнительное снабжение
            Великана: если последней с фермы ушла его единица, двойной клик снимает это снабжение целиком, и все его
            единицы возвращаются своим фермам.
          </li>
          <li>
            <b>Жетон отряда {unit} в нижней панели</b> — дает ему снабжение: с выбранной фермы {farm}, а без выбора с
            той, что дотягивается до меньшего числа отрядов. Значок <b>«−»</b> на жетоне снимает последнее снабжение.
          </li>
          <li>
            <b>Жетон фермы {farm} в нижней панели</b> — выбирает ферму, с которой еще есть что раздать, и показывает ее
            на поле. Показатель <b>«голод»</b> показывает отряд, оставшийся без снабжения.
          </li>
          <li>
            <b>«Заново»</b> в нижней панели — отменяет всю вашу раздачу этого хода разом, чтобы разложить снабжение с
            чистого листа. Раздачу соперников она не трогает.
          </li>
        </ul>
        <p>
          Пока выбрана ферма, двойной клик по отряду, которого она может снабдить, сначала отдает ему снабжение с этой
          фермы, как обычный клик, а вторым кликом забирает его обратно — снабжение, отданное раньше, так не снять. У
          Великанов второй клик забирает не обязательно только что отданное: сначала дополнительное снабжение, если оно
          есть, иначе самое раннее базовое. Если же выбранная ферма снабдить отряд не может (он вне ее досягаемости или
          уже получил базовое и дополнительное снабжение), двойной клик снимает раньше отданное, как описано выше.
        </p>
        <p>
          Выбор фермы снимается кликом по ячейке, где нет ни вашего отряда, ни фермы, и сам — когда у фермы кончается
          снабжение. Учтите: клик по своей ферме, у которой еще осталось снабжение, выбирает ее, даже если это первый
          клик двойного клика, — а пока ни одна ферма не выбрана, так же срабатывает и клик по стоящему на ней отряду.
          После такого двойного клика ферма остается выбранной. Это касается и Великана: вместе с фермой под ним
          выбирается и он сам: его панель снабжения видна, пока вы не кликнете по другому отряду или ячейке.
        </p>
        <p>
          Снятие базового снабжения отряда убирает и его дополнительное: дополнительное снабжение без базового
          невозможно.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Панель оверлеев</h2>
        <p>
          В левом нижнем углу, справа от реакций, — кнопка {layers} слоев поля: она разворачивает панель слоев, а
          кнопка {expand} сворачивает ее обратно. Каждый значок
          включает свой слой; включенный значок яркий, выключенный — приглушенный. Слои ничего не меняют в партии,
          это только подсказки поверх поля.
        </p>
        <ul>
          <li>
            <ToggleIcon src={'/img/icons/quarter_zone_black.png'} title={'Зона кварталов'}/>
            <b>Зона кварталов</b> — штриховка ячеек в пределах 2 ячеек от кварталов любых городов (см. «Зона влияния
            кварталов» в разделе «Фаза Строительства»): новый город здесь основать нельзя, а вид штриховки
            подсказывает, можно ли поставить базовый квартал. Отряды штриховка может не учитывать. Включается сама при входе
            в фазу Строительства.
          </li>
          <li>
            <ToggleIcon src={'/img/icons/block.png'} title={'Заблокированные ячейки'}/>
            <b>Заблокированные ячейки</b> — строения и ключевые точки городов, заблокированные отрядами противника (в
            том числе нейтральными) или повреждениями: они не приносят доход и не работают.
          </li>
          <li>
            <ToggleIcon src={'/img/icons/coords.png'} title={'Координаты'}/>
            <b>Координаты</b> — служебные номера ячеек, удобно называть ячейки в разговоре.
          </li>
          <li>
            <ToggleIcon src={'/img/icons/d6.png'} title={'Отряды'}/>
            <b>Отряды</b> — скрывает все отряды с поля, чтобы рассмотреть застройку под ними. Сам включается обратно
            со сменой ходящего игрока, а в фазе Снабжения сетевой игры, где все ходят одновременно, — в ее начале и
            в конце.
          </li>
          <li>
            <ToggleIcon src={'/img/icons/fortress.png'} title={'Крепости'}/>
            <b>Крепости</b> — скрывает крепости, чтобы увидеть, что под ними построено. Возвращается тогда же, когда
            и отряды.
          </li>
          <li>
            <ToggleIcon src={'/img/icons/bust.png'} title={'Владельцы ячеек'}/>
            <b>Владельцы ячеек</b> — заливает ячейки городов цветом их владельца. Нейтральные города и ничейные
            ячейки остаются без заливки.
          </li>
          <li>
            <ToggleIcon src={'/img/icons/temple_black.png'} title={'Храмы'}/>
            <b>Храмы</b> — пути влияния всех храмов и очки, которые они приносят.
          </li>
          <li>
            <ToggleIcon src={'/img/icons/guild_black.png'} title={'Гильдии'}/>
            <b>Гильдии</b> — то же самое для гильдий и их дохода в монетах.
          </li>
          <li>
            <ToggleIcon src={'/img/icons/coins black.png'} title={'Доход'}/>
            <b>Доход</b> — доход каждой ячейки прямо на поле: рудники, руины, кварталы, военные строения.
          </li>
        </ul>
      </div>

      <div className="rules-page_section">
        <h2>Реакции</h2>
        <p>
          В сетевых матчах в левом нижнем углу есть кнопка {chat} — панель реакций. Сначала выбирается адресат, затем
          сама реакция; в матче на двоих шаг с выбором адресата пропускается. Есть и эмоции (насмешка, злорадство,
          досада), и «дипломатические» знаки — предложение мира, союза, торговли или культурного обмена.
        </p>
        <p>
          <b>Реакции видят все игроки матча, даже адресованные конкретному игроку.</b> Выбор адресата влияет только на
          то, кому реакция подписана, — скрытых сообщений в игре нет, договориться с одним соперником втайне от
          остальных не получится.
        </p>
        <p>
          Чтобы панель не превращалась в спам, отправки ограничены: две реакции подряд быстрее чем за 10 секунд
          включают паузу на следующие 10 секунд.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Мелочи, которые легко пропустить</h2>
        <ul>
          <li>
            Кнопка {info} в шапке нижней панели открывает раздел правил <b>текущей фазы</b> — не нужно искать его в
            оглавлении.
          </li>
          <li>
            Стрелка справа в шапке нижней панели сворачивает панель целиком, если она закрывает нужный кусок поля.
          </li>
          <li>
            Когда выбрана катапульта или отряд эльфов, поле за пределами их зоны обстрела затемняется: непрозрачными
            остаются только ячейки, по которым выстрел возможен по дальности и траектории. Работает и для чужих
            отрядов — можно кликнуть на катапульту соперника и посмотреть, что она простреливает.
          </li>
          <li>
            Значки игроков в шапке открывают боковую панель со списком участников: их фракции, монеты, очки и
            политики.
          </li>
          <li>
            В фазе Снабжения сетевой игры все ходят одновременно. Кнопка завершения хода и монеты с очками в шапке
            показывают вас, пока вы не завершили ход, а после — одного из тех, кого еще ждут. В списке игроков у тех,
            кто еще распределяет снабжение, песочные часы, у завершивших — галочка.
          </li>
          <li>
            В той же фазе остаток снабжения на фермах и будущий размер отрядов показываются только для ваших ферм и
            отрядов (зрителю и в записи матча — для всех игроков), так что раздачу соперников не видно. Исключение —
            отряды, нанятые крысолюдами за снабжение: они появляются на поле сразу, с размером 0, и пропадают, если
            крысолюды отменят найм. Сами размеры отрядов у всех меняются разом, когда фазу завершат все.
          </li>
          <li>
            Кнопка рынка политик слева открывает панель покупки; если политика уже куплена, верхняя половина кнопки
            сразу показывает вашу карточку.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default InterfaceRules;
